import {Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-data-modal',
  templateUrl: './data-modal.component.html',
  styleUrls: ['./data-modal.component.scss']
})
export class DataModalComponent implements OnInit {
  pageSize: number;
  p: number;
  total: number;
  dataCopy: any;
  searchType: string;
  @Input() data: any = [];
  @Input() title: string;
  @Input() dataKind: number; // 100 customers, 200 stations, 300 towns, 400 areas
  // tslint:disable-next-line:no-output-native
  @Output() result = new EventEmitter<any>();
  // tslint:disable-next-line:no-output-native
  @Output() close = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
    this.dataCopy = this.data;
    this.total = this.data?.length || 0;
    this.pageSize = 3;
    this.searchType = this.dataKind === 100 ? 'client' : 'station';
    console.log(this.dataCopy)
  }
  getDataCopy(): Array<any> {
    return this.dataCopy || [];
  }
  searchResponse(result: any): void {
    if (result.length) { this.data = result; }
    else { this.data = this.dataCopy; }
    this.total = this.data.length;
  }

  pageChanged(event): void {
    this.p = event;
  }

  emitSelection(value: any): void {
    this.result.emit(value);
  }
  emitClose(): void {
    this.close.emit(true);
  }
}
